export interface User {
  Role: string;
  Email: string;
  WWID: string;
}

export interface UserIdentity {
  email?: string | null;
  wwid?: string | null;
  username?: string | null;
}

// UI-only mappings. Backend APIs must independently enforce authorization.
// Keep only users that belong to this application.
export const users: User[] = [
  {
    Role: 'full_view',
    Email: 'chetan.rc@simadvisorytech.com',
    WWID: '',
  },{
    Role: 'full_view',
    Email: 'sneha.gupta@simadvisorytech.com',
    WWID: '',
  },
  {
    Role: 'full_view',
    Email: 'tanvi.chaudhari@simadvisory.com',
    WWID: '',
  },

  {
    Role: 'full_view',
    Email: 'juliet.gabriel@simadvisorytech.com',
    WWID: '',
  },
  {
    Role: 'dashboard_view',
    Email: '',
    WWID: 'pi796@cummins.com',
  },
  {
    Role: 'dashboard_view',
    Email: '',
    WWID: 'vw150@cummins.com',
  },
  {
    Role: 'dashboard_view',
    Email: '',
    WWID: 'rf682@cummins.com',
  },
  {
    Role: 'dashboard_view',
    Email: '',
    WWID: ' bd10u@cummins.com',
  },
  {
    Role: 'dashboard_view',
    Email: '',
    WWID: 'fp904@cummins.com',
  },
  {
    Role: 'full_view',
    Email: '',
    WWID: 'ak26l@cummins.com',
  },
  
  {
    Role: 'full_view',
    Email: '',
    WWID: 'cg975@cummins.com',
  },
  
  {
    Role: 'full_view',
    Email: '',
    WWID: 'wx437@cummins.com',
  },
  
  {
    Role: 'full_view',
    Email: '',
    WWID: 'aw65v@cummins.com',
  }

];

const normalizeIdentity = (value: unknown): string =>
  String(value ?? '').trim().toLowerCase();

export function getMappedRoleForUser(
  identity: UserIdentity,
  userList: readonly User[] = users,
): string | null {
  const email = normalizeIdentity(identity.email);
  const wwid = normalizeIdentity(identity.wwid) || normalizeIdentity(identity.username);

  if (!email && !wwid) return null;

  const match = userList.find((user) => {
    const mappedEmail = normalizeIdentity(user.Email);
    const mappedWwid = normalizeIdentity(user.WWID);
    return (!!email && !!mappedEmail && email === mappedEmail) ||
      (!!wwid && !!mappedWwid && wwid === mappedWwid);
  });

  const role = String(match?.Role ?? '').trim();
  return role || null;
}
